import axios from "axios";
import { ChecklistExitInterviewUpdateTypes } from "../../../../modules/accounts/components/settings/SettingsModel";
import secureLocalStorage from "react-secure-storage";
const baseURL = secureLocalStorage.getItem("baseURL");
// Add New check_exit_interviews
export const add_check_exit_interview= async (values) => {
    let response = await axios.post(baseURL + "/api/exit-interview-checklist", values);
    return response.data;
}
// List of Departments active
export const get_all_active_departments = async () => {
  let response = await axios.get(baseURL + "/api/active-departments");
  return response.data;
}
// List of Locations Active
export const get_all_active_locations = async () => {
  let response = await axios.get(`${baseURL}/api/active-locations`);
  return response.data;
}
// List of check_exit_interviews
export const get_all_check_exit_interview= async () => {
    let response = await axios.get(baseURL + "/api/exit-interview-checklist");
    return response.data;
  }
// Delete check_exit_interviews 
  export const delete_check_exit_interview= async (id:number) => {
    let response = await axios.delete(baseURL + "/api/exit-interview-checklist/"+id);
    return response.data;
}

export const update_check_exit_interview = (id: number, updatedcheck_exit_interview: ChecklistExitInterviewUpdateTypes ) => {
  const { title, status,is_required, exit_interview_checklist_departments, exit_interview_checklist_locations } = updatedcheck_exit_interview;
  return axios.patch(`${baseURL}/api/exit-interview-checklist/${id}`, {
    title,
    status,
    is_required,
    exit_interview_checklist_departments,
    exit_interview_checklist_locations
  })
  .then(response => response.data);
};
// Get Single Check Exit Interview Log by ID
export const get_single_check_exit_interview_log = async (id: number) => {
  let response = await axios.get(`${baseURL}/api/exit-interview-checklist-activity-log/${id}`);
  return response.data;
};
// Get All Check Exit Interview Logs
export const get_all_check_exit_interview_logs = async () => {
  let response = await axios.get(`${baseURL}/api/exit-interview-checklist-activity-logs`);
  return response.data;
};
 //Filters on Check Exit Interview List
 export const get_all_filters_item_check_exit_interview=async (department,location,required,status) => {
  const response = await axios.post(baseURL + '/api/filter-exit-interview-checklist', {
    department_id:department,
    location_id:location,
    is_required:required,
    status:status
    });
    return response.data;
};